(() => {
  const WRAPPER = '.collection-wrapper';
  const OPEN = 'mox-plp-filters-open';
  const TOGGLE = '[data-mox-plp-filter-toggle]';
  const PANEL = '#mox-plp-filters-panel';

  const setOpen = (wrapper, open) => {
    wrapper.classList.toggle(OPEN, open);

    for (const btn of wrapper.querySelectorAll(TOGGLE)) {
      btn.setAttribute('aria-expanded', String(open));
    }

    const panel = wrapper.querySelector(PANEL);
    if (panel) {
      if (open) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const btn = target.closest(TOGGLE);
    if (!btn) return;

    const wrapper = btn.closest(WRAPPER);
    if (!wrapper) return;

    event.preventDefault();
    setOpen(wrapper, !wrapper.classList.contains(OPEN));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    for (const wrapper of document.querySelectorAll(`${WRAPPER}.${OPEN}`)) {
      setOpen(wrapper, false);
      const btn = wrapper.querySelector(TOGGLE);
      if (btn instanceof HTMLElement) btn.focus();
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.name !== 'sort_by') return;
    if (!target.closest('.mox-plp-panel-sort')) return;

    const formComponent = target.closest('facets-form-component');
    if (formComponent && 'updateFilters' in formComponent && typeof formComponent.updateFilters === 'function') {
      formComponent.updateFilters();
    }
  });
})();
